/**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2015, Codrops
 * http://www.codrops.com
 */
// ;(function(window) {

// 	'use strict';

// 	var support = { animations : Modernizr.cssanimations },
// 		animEndEventNames = { 'WebkitAnimation' : 'webkitAnimationEnd', 'OAnimation' : 'oAnimationEnd', 'msAnimation' : 'MSAnimationEnd', 'animation' : 'animationend' },
// 		animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ],
// 		onEndAnimation = function( el, callback ) {
// 			var onEndCallbackFn = function( ev ) {
// 				if( support.animations ) {
// 					if( ev.target != this ) return;
// 					this.removeEventListener( animEndEventName, onEndCallbackFn );
// 				}
// 				if( callback && typeof callback === 'function' ) { callback.call(); }
// 			};
// 			if( support.animations ) {
// 				el.addEventListener( animEndEventName, onEndCallbackFn );
// 			}
// 			else {
// 				onEndCallbackFn();
// 			}
// 		};

// 	// from http://www.sberry.me/articles/javascript-event-throttling-debouncing
// 	function throttle(fn, delay) {
// 		var allowSample = true;

// 		return function(e) {
// 			if (allowSample) {
// 				allowSample = false;
// 				setTimeout(function() { allowSample = true; }, delay);
// 				fn(e);
// 			}
// 		};
// 	}

// 	// sliders - flickity
// 	var sliders = [].slice.call(document.querySelectorAll('.slider')),
// 		// array where the flickity instances are going to be stored
// 		flkties = [],
// 		// grid element
// 		grid = document.querySelector('.grid_collection'),
// 		// isotope instance
// 		iso,
// 		// filter ctrls
// 		filterCtrls = [].slice.call(document.querySelectorAll('.filter > button'));

// 	function init() {
// 		// preload images
// 		imagesLoaded(grid, function() {
// 			initFlickity();
// 			initIsotope();
// 			initEvents();
// 			classie.remove(grid, 'grid--loading');
// 		});
// 	}

// 	function initFlickity() {
// 		sliders.forEach(function(slider){
// 			var flkty = new Flickity(slider, {
// 				prevNextButtons: false,
// 				wrapAround: true,
// 				cellAlign: 'left',
// 				contain: true,
// 				resize: false
// 			});

// 			// store flickity instances
// 			flkties.push(flkty);
// 		});
// 	}

// 	function initIsotope() {
// 		iso = new Isotope( grid, {
// 			isResizeBound: false,
// 			itemSelector: '.grid__item',
// 			percentPosition: true,
// 			masonry: {
// 				// use outer width of grid-sizer for columnWidth
// 				columnWidth: '.grid__sizer'
// 			},
// 			transitionDuration: '0.6s'
// 		});
// 	}

// 	function initEvents() {
// 		filterCtrls.forEach(function(filterCtrl) {
// 			filterCtrl.addEventListener('click', function() {
// 				classie.remove(filterCtrl.parentNode.querySelector('.filter__item--selected'), 'filter__item--selected');
// 				classie.add(filterCtrl, 'filter__item--selected');
// 				iso.arrange({
// 					filter: filterCtrl.getAttribute('data-filter')
// 				});
// 				recalcFlickities();
// 				iso.layout();
// 			});
// 		});

// 		// window resize / recalculate sizes for both flickity and isotope/masonry layouts
// 		window.addEventListener('resize', throttle(function(ev) {
// 			recalcFlickities()
// 			iso.layout();
// 		}, 50));
// 	}

// 	function recalcFlickities() {
// 		for(var i = 0, len = flkties.length; i < len; ++i) {
// 			flkties[i].resize();
// 		}
// 	}

// 	init();

// })(window);


//// Product Preview Slider


jQuery(document).ready(function($) {
	var galleryItems = $('.cd-gallery').children('li');

	galleryItems.each(function(){
		var container = $(this),
			// create slider dots
			sliderDots = createSliderDots(container);
		//check if item is on sale
		updatePrice(container, 0);

		// update slider when user clicks one of the dots
		sliderDots.on('click', function(){
			var selectedDot = $(this);
			if(!selectedDot.hasClass('selected')) {
				var selectedPosition = selectedDot.index(),
					activePosition = container.find('.cd-item-wrapper .selected').index();
				if( activePosition < selectedPosition) {
					nextSlide(container, sliderDots, selectedPosition);
				} else {
					prevSlide(container, sliderDots, selectedPosition);
				}

				updatePrice(container, selectedPosition);
			}
		});

		// update slider on swipeleft
		container.find('.cd-item-wrapper').on('swipeleft', function(){
			var wrapper = $(this);
			if( !wrapper.find('.selected').is(':last-child') ) {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() + 1;
				nextSlide(container, sliderDots);
				updatePrice(container, selectedPosition);
			}
		});

		// update slider on swiperight
		container.find('.cd-item-wrapper').on('swiperight', function(){
			var wrapper = $(this);
			if( !wrapper.find('.selected').is(':first-child') ) {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() - 1;
				prevSlide(container, sliderDots);
				updatePrice(container, selectedPosition);
			}
		});

		// preview image hover effect - desktop only
		container.on('mouseover', '.move-right, .move-left', function(event){
			hoverItem($(this), true);
		});
		container.on('mouseleave', '.move-right, .move-left', function(event){
			hoverItem($(this), false);
		});

		// update slider when user clicks on the preview images
		container.on('click', '.move-right, .move-left', function(event){
			event.preventDefault();
			if ( $(this).hasClass('move-right') ) {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() + 1;
				nextSlide(container, sliderDots);
			} else {
				var selectedPosition = container.find('.cd-item-wrapper .selected').index() - 1;
				prevSlide(container, sliderDots);
			}
			updatePrice(container, selectedPosition);
		});
	});

	function createSliderDots(container){
		var dotsWrapper = $('<ol class="cd-dots"></ol>').insertAfter(container.children('.image').children('a'));
		container.find('.cd-item-wrapper li').each(function(index){
			var dotWrapper = (index == 1) ? $('<li class="selected"></li>') : $('<li></li>'),
				dot = $('<a href="#0"></a>').appendTo(dotWrapper);
			dotWrapper.appendTo(dotsWrapper);
			dot.text(index+1);
		});
		return dotsWrapper.children('li');
	}

	function hoverItem(item, bool) {
		( item.hasClass('move-right') )
			? item.toggleClass('hover', bool).siblings('.selected, .move-left').toggleClass('focus-on-right', bool)
			: item.toggleClass('hover', bool).siblings('.selected, .move-right').toggleClass('focus-on-left', bool);
	}

	function nextSlide(container, dots, n){
		var visibleSlide = container.find('.cd-item-wrapper .selected'),
			navigationDot = container.find('.cd-dots .selected');
		if(typeof n === 'undefined') n = visibleSlide.index() + 1;
		visibleSlide.removeClass('selected');
		container.find('.cd-item-wrapper li').eq(n).addClass('selected').removeClass('move-right hover').prevAll().removeClass('move-right move-left focus-on-right').addClass('hide-left').end().prev().removeClass('hide-left').addClass('move-left').end().next().addClass('move-right');
		navigationDot.removeClass('selected')
		dots.eq(n).addClass('selected');
	}

	function prevSlide(container, dots, n){
		var visibleSlide = container.find('.cd-item-wrapper .selected'),
			navigationDot = container.find('.cd-dots .selected');
		if(typeof n === 'undefined') n = visibleSlide.index() - 1;
		visibleSlide.removeClass('selected focus-on-left');
		container.find('.cd-item-wrapper li').eq(n).addClass('selected').removeClass('move-left hide-left hover').nextAll().removeClass('hide-left move-right move-left focus-on-left').end().next().addClass('move-right').end().prev().removeClass('hide-left').addClass('move-left');
		navigationDot.removeClass('selected');
		dots.eq(n).addClass('selected');
	}

	function updatePrice(container, n) {
		var priceTag = container.find('.cd-price'),
			selectedItem = container.find('.cd-item-wrapper li').eq(n);
		if( selectedItem.data('sale') ) { 
			// if item is on sale - cross old price and add new one
// 			priceTag.addClass('on-sale');
// 			var newPriceTag = ( priceTag.next('.cd-new-price').length > 0 ) ? priceTag.next('.cd-new-price') : $('<em class="cd-new-price"></em>').insertAfter(priceTag);
// 			newPriceTag.text(selectedItem.data('price'));
// 			setTimeout(function(){ newPriceTag.addClass('is-visible'); }, 100);
          
//           	Currency.convertAll(Currency.currentCurrency, $("#currencies a.selected").data("currency"), "span.money", "money_format")
		} else {
			// if item is not on sale - remove cross on old price and sale price
			priceTag.removeClass('on-sale').next('.cd-new-price').removeClass('is-visible').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
				priceTag.next('.cd-new-price').remove();
			});
		}
	}
});
/**
 * jQuery Angle View v1.3
 *
 * @author Dymyw <dymayongwei@163.com>
 * @since 2013-12-23
 * @version 2014-09-03
 */

(function($) {
    // plugin definition
    $.fn.angle = function(configs) {
        if ('object' === typeof configs) {
            return this.each(function() {
                new $.angle(this, configs);
            });
        } else {
            var $angle = this.data('angle');
            switch (configs) {
                case 'resize':
                    $angle.init(); break;
            }
        }
    };

    /**
     * plugin defaults - added as a property on our plugin function
     *
     * @param float speed       show speed, default: 2
     * @param boolean drag      mouse drag or mouse over
     * @param selector previous click to display the previous
     * @param selector next     click to display the next
	 * @param integer current	set the display one
     * @param get_image         get image: js array object
     * @param after         	after: exec after every angle slide
     */
    $.fn.angle.defaults = {
        speed: 2,
        drag: false,
        previous: '',
        next: '',
        current: 0,
        get_image: function() {},
        after: function() {}
    };

    // object instance
    $.angle = function(container, configs) {
        var options = $.extend({}, $.fn.angle.defaults, configs);
        // store a reference to the slider object
        var $angle = $(container);
        $.data(container, 'angle', $angle);

        var width, firstImage, imageLeft, allImage, imageCount, changeWidth;

        var step = 0;
        var currentStep = 0;
        var currentImage;
        $angle.attr('data-current', options.current);

        var start = false;
        var startDrag = false;
        var startTouch = false;
        var isScrolling;
        var load = true;

        var init = function() {
            // get the parentNode width
            width = $(container.parentNode).css('width');
            if (!width || width.indexOf('%') !== -1) {
                width = container.parentNode.getBoundingClientRect().width || container.parentNode.offsetWidth;
            }
            width = parseInt(width);
            //$angle.width(width);

            firstImage = $angle.find('img:first');
            imageLeft = firstImage.offset().left;
            allImage = $angle.find('img');
            allImage.each(function(i) {
//                $(this).width(width);
                $(this).attr('data-id', i);
            });
            imageCount = allImage.size();
            changeWidth = parseInt(width / imageCount / options.speed);
            allImage.toggle();
            currentImage = $angle.data('current');
            allImage.eq(currentImage).toggle();
        };

        var loading = function() {
            load = false;
            var images = options.get_image();
            if ('object' === typeof images) {
                var ulString = '';
                for (var i in images) {
                    ulString += '<li><img src="' + images[i] + '" /></li>';
                }
                $(container).children('ul').html(ulString);
                init();
                mouseEvent();
            }
        };

        if (options.previous) {
            $(options.previous).click(function() {
                if (load) { loading(); }
                prev();
            });
        }
        if (options.next) {
            $(options.next).click(function() {
                if (load) { loading(); }
                next();
            });
        }

        var prev = function() {
            allImage.eq(currentImage).toggle();
            currentImage = circle(currentImage - 1);
            allImage.eq(currentImage).toggle();
            $angle.attr('data-current', currentImage);
            // callback function after
            _loadFn(options.after());
        };

        var next = function() {
            allImage.eq(currentImage).toggle();
            currentImage = circle(currentImage + 1);
            allImage.eq(currentImage).toggle();
            $angle.attr('data-current', currentImage);
            // callback function after
            _loadFn(options.after());
        };

        var circle = function(index) {
            return (imageCount + (index % imageCount)) % imageCount;
        };

        // touch event
        var bindTouchEvent = {
            handleEvent: function(event) {
                switch (event.type) {
                    case 'touchstart':
                        this.start(event);
                        break;
                    case 'touchmove':
                        this.move(event);
                        break;
                    case 'touchend':
                        this.end();
                        break;
                }
            },

            start: function(event) {
                startTouch = true;

                if (startTouch) {
                    var touchs = event.touches[0];
                    startPos = {
                        x: touchs.pageX,
                        y: touchs.pageY
                    };

                    if (load) { loading(); }
                    step = currentStep = parseInt((startPos.x - imageLeft) / changeWidth);

                    // used for testing first move event
                    isScrolling = undefined;

                    // reset delta and end measurements
                    delta = {};

                    // attach touchmove and touchend listeners
                    container.addEventListener('touchmove', this, false);
                    container.addEventListener('touchend', this, false);
                }
            },

            move: function(event) {
                if (startTouch) {
                    var touchs = event.touches[0];
                    delta = {
                        x: touchs.pageX - startPos.x,
                        y: touchs.pageY - startPos.y
                    };

                    // determine if scrolling test has run - one time test
                    if ('undefined' === typeof isScrolling) {
                        isScrolling = !!(isScrolling || Math.abs(delta.x) < Math.abs(delta.y));
                    }

                    if (!isScrolling) {
                        event.preventDefault();

                        currentStep = parseInt((touchs.pageX - imageLeft) / changeWidth);
                        if (currentStep !== step) {
                            currentStep > step ? next() : prev();
                            step = currentStep;
                        }
                    }
                }
            },

            end: function() {
                startTouch = false;

                // kill touchmove and touchend event listeners until touchstart called again
                container.removeEventListener('touchmove', this, false);
                container.removeEventListener('touchend', this, false);
            }
        };

        // bind mouse event
        var mouseEvent = function() {
            if (options.drag) {
                var dragX = null;
                // all images are forbidden to drag
                for (i in document.images)
                    document.images[i].ondragstart = function() {return false;};

                $(container).mousedown(function(event) {
                    startDrag = true;

                    if (startDrag) {
                        dragX = event.screenX;

                        if (load) { loading(); }
                        step = currentStep = parseInt((dragX - imageLeft) / changeWidth);
                    }
                });

                $(container).mousemove(function(event) {
                    if (startDrag && dragX) {
                        event.preventDefault();

                        currentStep = parseInt((event.screenX - imageLeft) / changeWidth);
                        if (currentStep !== step) {
                            currentStep > step ? next() : prev();
                            step = currentStep;
                        }
                    }
                });

                $(container).mouseup(function() {
                    start = false;
                    dragX = null;
                });
            } else {
                $(container).mouseover(function(event) {
                    start = true;

                    if (start) {
                        if (load) { loading(); }
                        step = currentStep = parseInt((event.screenX - imageLeft) / changeWidth);
                    }
                });

                $(container).mousemove(function(event) {
                    if (start) {
                        currentStep = parseInt((event.screenX - imageLeft) / changeWidth);
                        if (currentStep !== step) {
                            currentStep > step ? next() : prev();
                            step = currentStep;
                        }
                    }
                });

                $(container).mouseout(function() {
                    start = false;
                });
            }
        };

        // bind touch event
        if ('ontouchstart' in window) {
            container.addEventListener('touchstart', bindTouchEvent, false);
        }

        $angle.setPosition = function(i) {
            this.find("img[data-id='" + i + "']").css('display', 'inline');
            this.find("img[data-id!='" + i + "']").css('display', 'none');
            $angle.attr('data-current', i);
            currentImage = i;
        };

        var _loadFn = function(fn) {
            setTimeout(function() {
                fn;
            }, 0);
        };

        init();
        mouseEvent();
    };

    // private function - debugging
    function debug(obj) {
        if (window.console && window.console.log)
            window.console.log(obj);
    }
})(jQuery);